import { render } from "./ChallengeEditForm.vue?vue&type=template&id=5a6e875d"
import script from "./ChallengeEditForm.vue?vue&type=script&lang=js"
export * from "./ChallengeEditForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__